// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4npODNxZtwnQdwao6CwA {
    width: 100%;
    overflow: auto;
}

._4npODNxZtwnQdwao6CwA::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

._4npODNxZtwnQdwao6CwA::-webkit-scrollbar-thumb {
    background: #e0e0e0;
}

._4npODNxZtwnQdwao6CwA::-webkit-scrollbar-track {
    background: #eeeeee;
}

table {
    width: 100%;
    max-height:  calc(100% - 110px);
    border-spacing: 0;
    border-collapse: collapse;
}

th, td {
    font-family: "Nunito Sans", Sans-serif, serif;
    padding: 15px;
    font-size: 16px;
    border: 0;
    margin: 0;
    border-collapse: collapse;
}

thead tr:hover {
    cursor: default;
    background-color: transparent;
}

th {
    color: #004BA0;
    text-align: left;
    border-bottom: 1px solid #d0d0d0;
}

tbody {
    overflow-y: scroll;
    max-height: 85%;
}

tr:hover {
    cursor: pointer;
    background-color: #f5f5f5;
}

td img {
    width: 16px;
}

.FsLxl3fQOkUPB37TsARX {
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
}

@media screen and (max-width: 1500px) {
    th, td {
        font-size: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/admin/css/table-container.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,aAAa;IACb,eAAe;IACf,SAAS;IACT,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".table_holder {\n    width: 100%;\n    overflow: auto;\n}\n\n.table_holder::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n}\n\n.table_holder::-webkit-scrollbar-thumb {\n    background: #e0e0e0;\n}\n\n.table_holder::-webkit-scrollbar-track {\n    background: #eeeeee;\n}\n\ntable {\n    width: 100%;\n    max-height:  calc(100% - 110px);\n    border-spacing: 0;\n    border-collapse: collapse;\n}\n\nth, td {\n    font-family: \"Nunito Sans\", Sans-serif, serif;\n    padding: 15px;\n    font-size: 16px;\n    border: 0;\n    margin: 0;\n    border-collapse: collapse;\n}\n\nthead tr:hover {\n    cursor: default;\n    background-color: transparent;\n}\n\nth {\n    color: #004BA0;\n    text-align: left;\n    border-bottom: 1px solid #d0d0d0;\n}\n\ntbody {\n    overflow-y: scroll;\n    max-height: 85%;\n}\n\ntr:hover {\n    cursor: pointer;\n    background-color: #f5f5f5;\n}\n\ntd img {\n    width: 16px;\n}\n\n.pagination_holder {\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n@media screen and (max-width: 1500px) {\n    th, td {\n        font-size: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table_holder": `_4npODNxZtwnQdwao6CwA`,
	"pagination_holder": `FsLxl3fQOkUPB37TsARX`
};
export default ___CSS_LOADER_EXPORT___;
